import React, { useCallback } from 'react'
import context from '@/context'
import { ValidationBoundary } from '@/components/validation'
import { ModalBody, Row } from 'reactstrap'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { FormLoader, FormRow } from '@/components/changeRequests'
import { ValidDates } from '@/components/changeRequests/common/validDates'
import { ChangeItemDialogFooter } from '@/dialogs/common/changeItemDialogFooter'
import { ChangeItemFileAttachments } from '@/components/changeRequests/fileAttachments'
import { usePropertyReader } from '@/hooks/usePropertyReader'

const FormInternal = ({ target }) => {
  const [personalIdType] = usePropertyReader(['type'])
  const isValidToRequired = (personalIdType || {}).hasValidToRequired === true
  return (
    <div className='col-12'>
      <FormRow label='Individuals.PersonalIdType' name='type' target={target} inputType='lookup' dataSource={context.cache.getPersonalIdTypes} clientSide isCodeList required />
      <FormRow label='Individuals.PersonalIdNumber' name='number' target={target} required />
      <ValidDates validFromRequired validToRequired={isValidToRequired} target={target} />
    </div>
  )
}

function PersonalIdDialog (props) {
  const getAttachmentsTableData = useCallback((req) => context.api.individualService.getPersonalIdAttachmentsTableData(props.id, req), [props.id])

  return (
    <FormLoader {...props} render={() =>
      <ValidationBoundary>
        <BasicHeader title='Individuals.PersonalId' {...props} />
        <ModalBody>
          <Row>
            <FormInternal target={props.target} />
          </Row>
          <Row>
            <div className='col-12'>
              <ChangeItemFileAttachments
                target={props.target}
                name='attachments'
                dataSource={getAttachmentsTableData}
                downloadAction={context.api.individualService.downloadPersonalIdAttachment}
                simpleView
                attachmentsView />
            </div>
          </Row>
        </ModalBody>
        <ChangeItemDialogFooter {...props} />
      </ValidationBoundary>
    } />
  )
}

export default {
  modalProps: {
    size: 'lg'
  },
  component: PersonalIdDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/personalId.js